import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit {

 
  user = {
    type: 1,
    guid: '',
    display_name: '',
    username: '',
    email: '',
    is_admin: false,
    active: true

  }
  constructor(private modalController: ModalController,private apiService: ApiService,public globalService: GlobalService,private alertController: AlertController) { }

  ngOnInit() {
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async Create() {
    console.log(this.user);
    this.user.username = this.user.email;
    if(this.user.display_name == "") {
      this.globalService.presentToastMessage('Empty Display Name',false);
      return;
    }
    if(this.user.username == "") {
      this.globalService.presentToastMessage('Empty Username',false);
      return;
    }
    if(!this.globalService.validateEmail(this.user.email))  {
      this.globalService.presentToastMessage('Invalid Email',false);
      return;
    }
    this.globalService.presentLoading('Creating user...', 99999999);
   let data: any = await this.apiService.post('team_members',this.user);
   console.log(data);
   this.globalService.dismissLoading();
   this.globalService.presentToastMessage(data.message,data.success);
   if(data.success) {
    this.modalController.dismiss(data);
   }

  }


}
